import React, { useEffect, useState } from "react";
import { useTranslate } from "@tolgee/react";
import { Container, Content, Card, Header, Title, Subtitle } from "../shared/OnboardingStyles";
import { ErrorText } from "../shared/AuthUI";
import UserProfileForm from "../UserProfileForm";
import CulturalBgInfoModal from "../CulturalBgInfoModal";
import { useAuthService } from "../../../Context/AuthContext";
import { useLinksquaredService } from "../../../Context/LinksquaredContext";
import useLanguagePreFill from "../../../hooks/useLanguagePreFill";
import { registerWithEmail } from "../../../API/emailAuth";
import { buildUserProfile } from "../../../Helpers/buildUserProfile";
import { getAuthErrorMessage } from "../../../API/emailAuthErrors";
import { useNotify } from "../../../Helpers/Notifications";

const EmailProfileStep = ({
  email,
  otp,
  password,
  countryCode,
  onAuthSuccess,
  onRestart,
  setIsLoading,
}) => {
  const { t } = useTranslate();
  const { translationsLanguages, getTranslationsLanguages, getCallTranslationsLanguages } = useAuthService();
  const { getInvitedBy } = useLinksquaredService();
  const { notifyError } = useNotify();

  const [name, setName] = useState("");
  const [language, setLanguage] = useState("");
  const [culturalBg, setCulturalBg] = useState("");
  const [gender, setGender] = useState(null);
  const [birthday, setBirthday] = useState(null);
  const [isCulturalBgModalOpen, setIsCulturalBgModalOpen] = useState(false);
  const [error, setError] = useState(null);

  const canContinue = name.trim().length >= 3 && language !== "";

  useEffect(() => {
    getTranslationsLanguages(() => {}, () => {});
    getCallTranslationsLanguages(() => {}, () => {});
  }, []);

  useLanguagePreFill(language, setLanguage, translationsLanguages);

  const handleContinue = () => {
    if (!canContinue) return;
    setError(null);
    setIsLoading(true);

    const profile = buildUserProfile({
      name, language, culturalBg, gender, birthday,
      countryCode,
      invitedBy: getInvitedBy(),
    });

    registerWithEmail(
      email, otp, password, profile,
      (response) => {
        setIsLoading(false);
        onAuthSuccess(response.data.token, response.data.refresh_token);
      },
      (err) => {
        setIsLoading(false);
        const code = err?.response?.data?.error;
        if (code === "code_expired") {
          notifyError(getAuthErrorMessage(code, t));
          onRestart();
          return;
        }
        setError(getAuthErrorMessage(code, t));
      }
    );
  };

  return (
    <Container>
      {isCulturalBgModalOpen && (
        <CulturalBgInfoModal openModal={() => setIsCulturalBgModalOpen(false)} />
      )}
      <Content>
        <Card>
          <Header>
            <Title>{t("authentication.onboarding.header_title")}</Title>
            <Subtitle>{t("authentication.onboarding.header_subtitle")}</Subtitle>
          </Header>
          <UserProfileForm
            name={name} setName={setName}
            language={language} setLanguage={setLanguage}
            translationsLanguages={translationsLanguages}
            birthday={birthday} setBirthday={setBirthday}
            gender={gender} setGender={setGender}
            culturalBg={culturalBg} setCulturalBg={setCulturalBg}
            onInfoClick={() => setIsCulturalBgModalOpen(true)}
            canContinue={canContinue}
            onContinue={handleContinue}
          />
          {error && <ErrorText>{error}</ErrorText>}
        </Card>
      </Content>
    </Container>
  );
};

export default EmailProfileStep;
